import { customAxios, FDV_URL,IDUSUARIO } from '../constants';

export default function(values) {
  const initialValues = {
    // codVendedor: 'V251',
    // codFilial: '044',
    codTipoFicha: '01',
    codMoneda: values.moneda,
    codTipoPago: values.codTipoPago,
  };

  const data = Object.assign(initialValues, values);

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    
    },
  };



  return customAxios.post(`${FDV_URL}/ficha-venta/fichas-venta`, data,config);
}



// WEBPACK FOOTER //
// ./src/utils/createFichaVenta.js